import { render } from "./AppBasketball.vue?vue&type=template&id=46e51bec&ts=true"
import script from "./AppBasketball.vue?vue&type=script&lang=ts"
export * from "./AppBasketball.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__